import React from "react";
// import { styleClassName } from "../../styleHelper";
import Gambit from "../../Gambit";
import { GambitDataProps } from "../types";

export default function SelectableGambit(props: GambitDataProps) {
  const { gambit, actions, editable } = props;
  const { id } = gambit;
  // const { id, active = false } = gambit;
  // const onChange = (e: React.ChangeEvent<HTMLInputElement>) =>
  // actions.toggleItemActive(e.target.id);
  const onClick = () => actions.changeItem(id);
  // const labelClassName = styleClassName("nes-checkbox");
  // console.log(editable);
  return (
    <div className="selectable-gambit">
      {/* <label htmlFor={id}>
        <input
          id={id}
          disabled
          type="checkbox"
          className={labelClassName}
          checked={active}
          onChange={onChange}
        />
        <span />
      </label> */}
      <Gambit gambit={gambit} clickHandler={onClick} editable={editable} />
    </div>
  );
}
